const Footer = () => {
  return (
    <footer
      className="bg-[var(--bg-footer)] text-center px-3 py-1"
      style={{ backgroundColor: 'var(--background)', color: 'var(--slate)' }}
    >
      {/* Mobile Social Icons */}
      <div className="lg:hidden block w-full max-w-[270px] mx-auto mb-6">
        <ul className="flex justify-between items-center">
          {/* GitHub */}
          <li>
            <a
              href="https://github.com/rakesh-honawad"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
              className="hover:text-green-400 hover:scale-110 transition-transform duration-300"
            >
              <svg
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 0C5.37 0 0 5.373 0 12a12 12 0 008.207 11.387c.6.11.793-.26.793-.577v-2.021c-3.338.724-4.033-1.61-4.033-1.61-.546-1.387-1.333-1.756-1.333-1.756-1.09-.745.082-.729.082-.729 1.205.086 1.838 1.236 1.838 1.236 1.07 1.834 2.807 1.304 3.493.997.107-.775.42-1.305.763-1.605-2.665-.305-5.466-1.335-5.466-5.932 0-1.31.468-2.381 1.236-3.221-.124-.304-.535-1.526.116-3.176 0 0 1.008-.322 3.3 1.23a11.49 11.49 0 013.003-.404c1.02.005 2.047.137 3.003.404 2.29-1.552 3.297-1.23 3.297-1.23.653 1.65.242 2.872.118 3.176.77.84 1.235 1.91 1.235 3.221 0 4.61-2.805 5.624-5.476 5.921.432.372.816 1.103.816 2.222v3.293c0 .32.192.694.8.576A12.005 12.005 0 0024 12c0-6.627-5.373-12-12-12z"
                />
              </svg>
            </a>
          </li>

          {/* LinkedIn */}
          <li>
            <a
              href="https://www.linkedin.com/in/rakesh-honawad"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="hover:text-green-400 hover:scale-110 transition-transform duration-300"
            >
              <svg
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M20.447 20.452H17.21V14.79c0-1.345-.028-3.078-1.88-3.078-1.881 0-2.169 1.466-2.169 2.975v5.765H9.06V9h3.105v1.561h.045c.433-.818 1.491-1.682 3.07-1.682 3.287 0 3.89 2.165 3.89 4.981v6.592zM5.337 7.433a1.802 1.802 0 01-1.794-1.81 1.81 1.81 0 111.794 1.81zM6.875 20.452H3.8V9h3.075v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.728v20.543C0 23.226.792 24 1.771 24h20.451C23.2 24 24 23.226 24 22.271V1.728C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
          </li>

          {/* Instagram */}
          <li>
            <a
              href="https://instagram.com/raki_1432_"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="hover:text-green-400 hover:scale-110 transition-transform duration-300"
            >
              <svg
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.056 1.96.24 2.418.403a4.92 4.92 0 011.675 1.096 4.92 4.92 0 011.096 1.675c.163.458.347 1.248.403 2.418.058 1.266.07 1.645.07 4.85s-.012 3.584-.07 4.85c-.056 1.17-.24 1.96-.403 2.418a4.902 4.902 0 01-1.096 1.675 4.902 4.902 0 01-1.675 1.096c-.458.163-1.248.347-2.418.403-1.266.058-1.645.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.056-1.96-.24-2.418-.403a4.92 4.92 0 01-1.675-1.096 4.92 4.92 0 01-1.096-1.675c-.163-.458-.347-1.248-.403-2.418C2.175 15.747 2.163 15.368 2.163 12s.012-3.584.07-4.85c.056-1.17.24-1.96.403-2.418a4.92 4.92 0 011.096-1.675A4.92 4.92 0 015.407 2.636c.458-.163 1.248-.347 2.418-.403C8.416 2.175 8.795 2.163 12 2.163zm0-2.163C8.736 0 8.332.014 7.052.072 5.72.132 4.665.317 3.737.634a7.147 7.147 0 00-2.6 1.626A7.15 7.15 0 00.511 4.859C.194 5.788.009 6.843-.051 8.176-.108 9.456-.122 9.86-.122 12s.014 2.544.072 3.824c.06 1.333.245 2.388.562 3.317a7.15 7.15 0 001.626 2.6 7.15 7.15 0 002.6 1.626c.93.317 1.985.502 3.317.562 1.28.058 1.684.072 3.824.072s2.544-.014 3.824-.072c1.333-.06 2.388-.245 3.317-.562a7.15 7.15 0 002.6-1.626 7.15 7.15 0 001.626-2.6c.317-.93.502-1.985.562-3.317.058-1.28.072-1.684.072-3.824s-.014-2.544-.072-3.824c-.06-1.333-.245-2.388-.562-3.317a7.15 7.15 0 00-1.626-2.6A7.15 7.15 0 0020.263.634C19.334.317 18.279.132 16.948.072 15.668.014 15.264 0 12 0zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a3.999 3.999 0 110-7.998 3.999 3.999 0 010 7.998zm6.406-11.845a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z" />
              </svg>
            </a>
          </li>
        </ul>
      </div>
      {/* Footer Text */}
      <div style={{ color: "yellowgreen" }} className="text-xs tracking-wide py-4">
        Made with <span style={{ color: 'var(--green)' }}>❤️</span> by Rakesh Honawad
      </div>
    </footer>
  );
};

export default Footer;
